import { render } from "./TheSwapButton.vue?vue&type=template&id=296ee2e0"
import script from "./TheSwapButton.vue?vue&type=script&lang=js"
export * from "./TheSwapButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__